<style lang="scss">
.navigation-overlay {
    position: fixed;
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100); //vh fix from app.js
    z-index: 5000;
    top: 0;
    left: 0;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0s 0.2s;

    &.active {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.2s;
    }
    
    .hamburger-button {    
        padding: 24px 14px !important;
    }

    .link-white {
        text-decoration: none !important;
        transition: color 0.15s;

        &:hover {
            color: #f39225 !important;
        }
    }

    .icon-heart {
        color: #f39225 !important;

        &:before {
            background: url('/svg/heart-accent.svg') !important;
        }
    }

    @media screen and (min-width: 768px) {
        .link-white, .link-accent {
            font-size: 2rem;
        }
    }
}

/**
 * Disable body scrolling when overlayer is visible
 */

body.navigation-active {
    overflow: hidden;
    width: 100vw;
    height: calc(100vh - 64px);
    height: calc(var(--vh, 1vh) * 100 - 64px); //vh fix from app.js
}
</style>

<template>
    <div class="navigation-overlay bg-dark" :class="{'active': $root.navigationIsVisble}">
        <div class="navigation-overlay-inner h-100 d-lg-flex flex-column justify-content-center">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {

}
</script>